import styled from 'styled-components';

const DetailContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 850px) {
    flex-direction: column;
  }
`;

export default DetailContainer;
